/**
 * SuperAdminPill — small ember/violet badge surfaced in the portal top-bar
 * whenever the logged-in user has `is_super_admin === true`. Makes it visually
 * impossible to miss when you're operating in god-mode (no credit gating, all
 * models unlocked, all tenants visible).
 */
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';

export const SuperAdminPill = ({ compact = false }) => {
  return (
    <motion.span
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ type: 'spring', stiffness: 300, damping: 24 }}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-semibold uppercase tracking-[0.08em] select-none"
      style={{
        background: 'linear-gradient(135deg, rgba(167,139,250,0.18) 0%, rgba(242,107,31,0.18) 100%)',
        border: '1px solid rgba(167,139,250,0.45)',
        color: '#C4B5FD',
        boxShadow: '0 0 0 1px rgba(167,139,250,0.10), 0 4px 14px -6px rgba(167,139,250,0.35)',
      }}
      title="You are signed in as a Cognara platform super-admin — unlimited credits, all models unlocked, every tenant visible."
      data-testid="super-admin-pill"
    >
      <ShieldCheck size={11} style={{ color: '#A78BFA' }} />
      <span>{compact ? 'SUPER' : 'SUPER ADMIN'}</span>
    </motion.span>
  );
};

export default SuperAdminPill;
